import { createFileRoute } from "@tanstack/react-router";
import { AdditionalCostsSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/resources/additional-costs")({
  component: AdditionalCostsSettingsPage,
});
